/**
 * PLZ → Netzbetreiber + Netzentgelt
 *
 * Primaere Quelle: netzbetreiberDB.json (730 exakte PLZ-Zuordnungen, Quelle: ESOS24)
 * Fallback: 2-stelliger PLZ-Prefix → regionale Zuordnung
 * Netzentgelte in ct/kWh (Niederspannung, Stand 2026)
 */

import EXACT_PLZ_DB from './netzbetreiberDB.json';

const NETZBETREIBER_MAP = {
  // Berlin
  '10': { name: 'Stromnetz Berlin GmbH', netzentgelt: 7.85, region: 'Berlin' },
  '12': { name: 'Stromnetz Berlin GmbH', netzentgelt: 7.85, region: 'Berlin' },
  '13': { name: 'Stromnetz Berlin GmbH', netzentgelt: 7.85, region: 'Berlin' },
  '14': { name: 'E.DIS Netz GmbH', netzentgelt: 9.12, region: 'Brandenburg' },
  '15': { name: 'E.DIS Netz GmbH', netzentgelt: 9.12, region: 'Brandenburg' },
  '16': { name: 'E.DIS Netz GmbH', netzentgelt: 9.12, region: 'Brandenburg' },
  '17': { name: 'E.DIS Netz GmbH', netzentgelt: 9.12, region: 'Mecklenburg-Vorpommern' },
  '18': { name: 'E.DIS Netz GmbH', netzentgelt: 9.12, region: 'Mecklenburg-Vorpommern' },
  '19': { name: 'WEMAG Netz GmbH', netzentgelt: 9.45, region: 'Mecklenburg-Vorpommern' },

  // Hamburg
  '20': { name: 'Stromnetz Hamburg GmbH', netzentgelt: 6.92, region: 'Hamburg' },
  '21': { name: 'Stromnetz Hamburg GmbH', netzentgelt: 6.92, region: 'Hamburg' },
  '22': { name: 'Stromnetz Hamburg GmbH', netzentgelt: 6.92, region: 'Hamburg' },
  '23': { name: 'Schleswig-Holstein Netz AG', netzentgelt: 8.76, region: 'Schleswig-Holstein' },
  '24': { name: 'Schleswig-Holstein Netz AG', netzentgelt: 8.76, region: 'Schleswig-Holstein' },
  '25': { name: 'Schleswig-Holstein Netz AG', netzentgelt: 8.76, region: 'Schleswig-Holstein' },
  '26': { name: 'EWE NETZ GmbH', netzentgelt: 8.34, region: 'Niedersachsen' },
  '27': { name: 'EWE NETZ GmbH', netzentgelt: 8.34, region: 'Niedersachsen' },
  '28': { name: 'Wesernetz Bremen GmbH', netzentgelt: 7.28, region: 'Bremen' },
  '29': { name: 'Avacon Netz GmbH', netzentgelt: 8.56, region: 'Niedersachsen' },

  // Hannover / Niedersachsen
  '30': { name: 'enercity Netz GmbH', netzentgelt: 7.14, region: 'Niedersachsen' },
  '31': { name: 'Avacon Netz GmbH', netzentgelt: 8.56, region: 'Niedersachsen' },
  '32': { name: 'Westfalen Weser Netz GmbH', netzentgelt: 8.21, region: 'NRW' },
  '33': { name: 'Westfalen Weser Netz GmbH', netzentgelt: 8.21, region: 'NRW' },
  '34': { name: 'EAM Netz GmbH', netzentgelt: 8.89, region: 'Hessen' },
  '35': { name: 'EAM Netz GmbH', netzentgelt: 8.89, region: 'Hessen' },
  '36': { name: 'EAM Netz GmbH', netzentgelt: 8.89, region: 'Hessen' },
  '37': { name: 'EAM Netz GmbH', netzentgelt: 8.89, region: 'Hessen' },
  '38': { name: 'Avacon Netz GmbH', netzentgelt: 8.56, region: 'Niedersachsen' },
  '39': { name: 'Avacon Netz GmbH', netzentgelt: 8.56, region: 'Sachsen-Anhalt' },

  // Duesseldorf / NRW
  '40': { name: 'Netz Duesseldorf GmbH', netzentgelt: 6.78, region: 'NRW' },
  '41': { name: 'NEW Netz GmbH', netzentgelt: 7.45, region: 'NRW' },
  '42': { name: 'WSW Netz GmbH', netzentgelt: 7.89, region: 'NRW' },
  '43': { name: 'Enervie Vernetzt GmbH', netzentgelt: 8.12, region: 'NRW' },
  '44': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },
  '45': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },
  '46': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },
  '47': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },
  '48': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },
  '49': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },

  // Koeln / Bonn
  '50': { name: 'Rheinische NETZGesellschaft mbH', netzentgelt: 6.95, region: 'NRW' },
  '51': { name: 'Rheinische NETZGesellschaft mbH', netzentgelt: 6.95, region: 'NRW' },
  '52': { name: 'Regionetz GmbH', netzentgelt: 7.34, region: 'NRW' },
  '53': { name: 'BonnNetz GmbH', netzentgelt: 7.12, region: 'NRW' },
  '54': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'Rheinland-Pfalz' },
  '55': { name: 'Mainzer Netze GmbH', netzentgelt: 7.23, region: 'Rheinland-Pfalz' },
  '56': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'Rheinland-Pfalz' },
  '57': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },
  '58': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },
  '59': { name: 'Westnetz GmbH', netzentgelt: 7.56, region: 'NRW' },

  // Frankfurt / Hessen
  '60': { name: 'NRM Netzdienste Rhein-Main GmbH', netzentgelt: 6.89, region: 'Hessen' },
  '61': { name: 'NRM Netzdienste Rhein-Main GmbH', netzentgelt: 6.89, region: 'Hessen' },
  '63': { name: 'Syna GmbH', netzentgelt: 7.67, region: 'Hessen' },
  '64': { name: 'e-netz Suedhessen GmbH', netzentgelt: 7.45, region: 'Hessen' },
  '65': { name: 'NRM Netzdienste Rhein-Main GmbH', netzentgelt: 6.89, region: 'Hessen' },
  '66': { name: 'Energis-Netzgesellschaft mbH', netzentgelt: 7.78, region: 'Saarland' },
  '67': { name: 'Pfalzwerke Netz AG', netzentgelt: 7.56, region: 'Rheinland-Pfalz' },
  '68': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '69': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },

  // Stuttgart / Baden-Wuerttemberg
  '70': { name: 'Stuttgart Netze GmbH', netzentgelt: 7.34, region: 'Baden-Wuerttemberg' },
  '71': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '72': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '73': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '74': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '75': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '76': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '77': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '78': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '79': { name: 'bnNETZE GmbH', netzentgelt: 7.89, region: 'Baden-Wuerttemberg' },

  // Muenchen / Bayern
  '80': { name: 'SWM Infrastruktur GmbH', netzentgelt: 6.45, region: 'Bayern' },
  '81': { name: 'SWM Infrastruktur GmbH', netzentgelt: 6.45, region: 'Bayern' },
  '82': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '83': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '84': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '85': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '86': { name: 'LEW Verteilnetz GmbH', netzentgelt: 7.67, region: 'Bayern' },
  '87': { name: 'LEW Verteilnetz GmbH', netzentgelt: 7.67, region: 'Bayern' },
  '88': { name: 'Netze BW GmbH', netzentgelt: 8.23, region: 'Baden-Wuerttemberg' },
  '89': { name: 'LEW Verteilnetz GmbH', netzentgelt: 7.67, region: 'Bayern' },

  // Nuernberg / Franken
  '90': { name: 'N-ERGIE Netz GmbH', netzentgelt: 7.34, region: 'Bayern' },
  '91': { name: 'N-ERGIE Netz GmbH', netzentgelt: 7.34, region: 'Bayern' },
  '92': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '93': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '94': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '95': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '96': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '97': { name: 'Bayernwerk Netz GmbH', netzentgelt: 7.89, region: 'Bayern' },
  '98': { name: 'TEN Thueringer Energienetze GmbH', netzentgelt: 9.23, region: 'Thueringen' },
  '99': { name: 'TEN Thueringer Energienetze GmbH', netzentgelt: 9.23, region: 'Thueringen' },

  // Sachsen
  '01': { name: 'SachsenNetze GmbH', netzentgelt: 8.78, region: 'Sachsen' },
  '02': { name: 'SachsenNetze GmbH', netzentgelt: 8.78, region: 'Sachsen' },
  '03': { name: 'MITNETZ STROM mbH', netzentgelt: 9.34, region: 'Brandenburg' },
  '04': { name: 'Netz Leipzig GmbH', netzentgelt: 8.12, region: 'Sachsen' },

  // Sachsen-Anhalt
  '06': { name: 'MITNETZ STROM mbH', netzentgelt: 9.34, region: 'Sachsen-Anhalt' },
  '07': { name: 'TEN Thueringer Energienetze GmbH', netzentgelt: 9.23, region: 'Thueringen' },
  '08': { name: 'MITNETZ STROM mbH', netzentgelt: 9.34, region: 'Sachsen' },
  '09': { name: 'MITNETZ STROM mbH', netzentgelt: 9.34, region: 'Sachsen' },

  // Sonderfall: 62 fehlt im Postleitsystem → Frankfurt-Umland
  '62': { name: 'Syna GmbH', netzentgelt: 7.67, region: 'Hessen' },
  // 05 gibt es nicht als PLZ-Prefix
};

// Netzentgelt-Faktoren nach Spannungsebene (relativ zu NS)
const SPANNUNGSEBENE_FAKTOREN = {
  'NS': 1.0,
  'NS_MS': 0.75,
  'MS': 0.55,
  'MS_HS': 0.35,
  'HS': 0.25,
};

/**
 * Hilfsfunktion: Baut ein Ergebnis-Objekt fuer einen Netzbetreiber-Namen
 */
function buildResult(name, plz, spannungsebene, exact) {
  const faktor = SPANNUNGSEBENE_FAKTOREN[spannungsebene] || 1.0;
  const prefix = plz.substring(0, 2);
  const prefixEntry = NETZBETREIBER_MAP[prefix];
  const baseNetzentgelt = prefixEntry?.netzentgelt || 7.80;

  return {
    name,
    netzentgelt: Math.round(baseNetzentgelt * faktor * 10000) / 10000,
    netzentgelt_ns: baseNetzentgelt,
    region: prefixEntry?.region || '',
    exact,
  };
}

/**
 * Netzbetreiber und Netzentgelt fuer eine PLZ ermitteln.
 * Gibt bei mehreren Netzbetreibern den ersten zurueck.
 * Nutze getNetzbetreiberList() fuer alle Optionen.
 *
 * @param {string} plz - 5-stellige PLZ
 * @param {string} spannungsebene - NS, MS, HS, etc.
 * @returns {{ name: string, netzentgelt: number, region: string, exact: boolean } | null}
 */
export function getNetzbetreiber(plz, spannungsebene = 'NS') {
  const list = getNetzbetreiberList(plz, spannungsebene);
  return list.length > 0 ? list[0] : null;
}

/**
 * Alle Netzbetreiber fuer eine PLZ ermitteln (fuer Auswahl-Dropdown).
 * Bei PLZs mit mehreren Netzbetreibern kommt ein Array zurueck.
 *
 * @param {string} plz - 5-stellige PLZ
 * @param {string} spannungsebene - NS, MS, HS, etc.
 * @returns {Array<{ name: string, netzentgelt: number, region: string, exact: boolean }>}
 */
export function getNetzbetreiberList(plz, spannungsebene = 'NS') {
  if (!plz || plz.length < 2) return [];

  // 1. Exakte PLZ in der DB suchen
  const exactEntry = EXACT_PLZ_DB[plz];
  if (exactEntry) {
    // String = einzelner NB, Array = mehrere
    const names = Array.isArray(exactEntry) ? exactEntry : [exactEntry];
    return names.map(name => buildResult(name, plz, spannungsebene, true));
  }

  // 2. Naechste bekannte PLZ suchen (+-200)
  const plzNum = parseInt(plz);
  for (let offset = 1; offset <= 200; offset++) {
    for (const dir of [1, -1]) {
      const nearby = String(plzNum + offset * dir).padStart(5, '0');
      const nearbyEntry = EXACT_PLZ_DB[nearby];
      if (nearbyEntry) {
        const names = Array.isArray(nearbyEntry) ? nearbyEntry : [nearbyEntry];
        return names.map(name => buildResult(name, plz, spannungsebene, false));
      }
    }
  }

  // 3. Fallback: 2-stelliger Prefix
  const prefix = plz.substring(0, 2);
  const entry = NETZBETREIBER_MAP[prefix];
  if (!entry) return [];

  return [buildResult(entry.name, plz, spannungsebene, false)];
}

/**
 * Alle verfuegbaren Netzbetreiber (fuer Dropdown-Auswahl)
 */
export function getAllNetzbetreiber() {
  const unique = new Map();
  Object.values(NETZBETREIBER_MAP).forEach(entry => {
    if (!unique.has(entry.name)) {
      unique.set(entry.name, entry);
    }
  });
  return Array.from(unique.values()).sort((a, b) => a.name.localeCompare(b.name));
}

export default NETZBETREIBER_MAP;
